import { bool, oneOf, string } from "prop-types";
import { useMemo } from "react";

import styled from "styled-components";
import {
  borderRadius,
  glow,
  sizeIt,
  square,
  themeSizes,
  themeVariants,
} from "theme";

import {
  ensureLeadingHex,
  lightenDarkenColor,
} from "Utilities/Colors/colorUtils";

const SDiv = styled("div")`
  ${square}
  ${borderRadius}
  ${glow}
  ${sizeIt}
  transition: transform .3s ease-in-out, box-shadow .3s, background-color .3s ease-in-out;
`;

const ColorSquare = ({
  size = themeSizes.md,
  circle,
  backgroundColor: backgroundColorArg,
  selected,
  ...rest
}) => {
  const backgroundColor = ensureLeadingHex(backgroundColorArg);
  const variant = useMemo(() => {
    if (circle) return themeVariants.icon;
    if (selected) return themeVariants.emphasized;
    return themeVariants.square;
  }, [circle, selected]);
  return (
    <SDiv
      $variant={variant}
      $size={size}
      $noGlow={!selected}
      $scale={themeSizes.md}
      $glowColor={lightenDarkenColor(backgroundColor, 40)}
      $glowWidth={1}
      style={{ backgroundColor }} // using style since this will change a LOT. Let's not generate classnames for each change! 😬
      {...rest}
    />
  );
};

ColorSquare.propTypes = {
  size: oneOf(Object.values(themeSizes)),
  circle: bool,
  backgroundColor: string,
  selected: bool,
};

export default ColorSquare;
